module.exports = __webpack_public_path__ + "img/swipe.ce370e3e.gif";